<script setup lang="ts">
import UThicknessRange from "~/common/components/U/Range/ThicknessRange.vue";
import { TELESTRATION_TOOLTIP_CONTAINER } from "~/telestrations/constants/tooltip";

const { t } = useI18n();
const shapesStore = useShapesStore();
const thicknessValue = ref<number>(1);

const MIN_THICKNESS = 1;
const MAX_THICKNESS = 20;

watchEffect(() => {
  thicknessValue.value = shapesStore.selectedShape?.strokeWidth ?? 1;
});

function onThicknessChange(e: Event) {
  const target = e.target as HTMLInputElement | null;
  if (!target) return;

  const inputValue = target.value.trim();
  let val = parseFloat(inputValue);

  if (!Number.isFinite(val)) {
    val = MIN_THICKNESS;
  }

  // Clamp thickness between min and max values
  val = Math.max(MIN_THICKNESS, Math.min(MAX_THICKNESS, val));
  thicknessValue.value = val;

  if (shapesStore.selectedShape) {
    shapesStore.updateShape(shapesStore.selectedShape, { strokeWidth: val });
    // Update transformer padding/position to account for stroke width change
    shapesStore.attachTransformerToShape(shapesStore.selectedShape);
    shapesStore.updateTransformerPosition();
  }
}
</script>

<template>
  <div class="flex w-[124px] items-center px-3.5 pb-2">
    <UThicknessRange
      v-tooltip="{ content: t('labels.thickness'), container: TELESTRATION_TOOLTIP_CONTAINER }"
      :model-value="thicknessValue"
      :min="MIN_THICKNESS"
      :max="MAX_THICKNESS"
      :step="1"
      class="h-3 flex-1"
      @update:model-value="onThicknessChange"
    />
  </div>
</template>
